import { useEffect } from "react";

import { SMALL_DEVICE_QUERY } from "~/const";
import { useMedia } from "./useMedia";
import { mainStore } from "~/stores/main";

export function useMediaResponsive() {
	const isSmallDevice = useMedia(SMALL_DEVICE_QUERY);

	useEffect(() => {
		mainStore.getState().setSmallDevice(isSmallDevice);
	}, [isSmallDevice]);
}
